import React, { Component } from 'react'
import 'react-datepicker/dist/react-datepicker.css'
import PropTypes from 'prop-types'
import { withTranslation } from 'react-i18next'
import { FormContainer } from '../Form'
import { isEmptyString } from '../../../../../../helpers/sanityChecks'
import { validateFields } from '../../../../../../helpers/collaborativeIndexations'
import Identity from './FormSteps/Identity.jsx'
import More from './FormSteps/More.jsx'
import { EventContainer } from './FormSteps/Event'

class PopulationCensusForm extends Component {

    static propTypes = {
        t: PropTypes.func.isRequired,
        fields: PropTypes.object.isRequired,
        defaultEventYear: PropTypes.number,
        defaultEventPlace: PropTypes.string,
    }

    constructor(props)
    {
        super(props)

        this.formSteps = [
            Identity,
            More,
            EventContainer,
        ]

        this.formStepsValidation = {
            2: () => {
                validateFields({
                    lastname: () => ! isEmptyString(this.props.fields.lastname),
                    age: () => {
                        const { age, birthYear } = this.props.fields

                        if(age !== null && birthYear !== null)
                        {
                            return false
                        }

                        const ageAsInt = Number.parseInt(age)

                        return age === null || (age === ageAsInt.toString() && ageAsInt >= 0 && ageAsInt <= 199)
                    },
                    birthYear: () => {
                        const { age, birthYear } = this.props.fields

                        return ! (age !== null && birthYear !== null)
                    },
                })
            },
        }
    }

    componentDidMount()
    {
        const { updateFieldValue, defaultEventYear, defaultEventPlace } = this.props

        updateFieldValue('eventYear', defaultEventYear)
        updateFieldValue('eventPlace', defaultEventPlace)
        updateFieldValue('eventType', 'population_census')
    }

    render()
    {
        return (
            <FormContainer steps={ this.formSteps } stepsValidation={ this.formStepsValidation } />
        )
    }
}

export default withTranslation()(PopulationCensusForm)
